module.exports = __webpack_public_path__ + "img/lost.a856e094.svg";